import styled from 'styled-components'

export const FieldLabel = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  margin: 8px 0 12px;
`
